var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"be-app__welcome-screen"},[_c('img',{staticClass:"be-app__welcome-screen__icon",attrs:{"src":_vm.IconBrand,"alt":"Belliata"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }